import React from 'react'

const Footer = () => {
  return (
    <footer className="bg-dark text-light py-3" >
      <p className="text-lg text-center m-auto">Copyright &copy; MyTodosList.com</p>
    </footer>
  )
}

export default Footer
